// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"t6-z"};